import React from 'react'
import Headline5 from '../../components/headings/Headline5'
import Modal from '../../components/modal'
import Table from '../../components/table'
import Button from "../../components/button";

const CheckHistory = (props: any) => {

  return (
    <Modal title={'History'} onClose={props.onClose} size='large'>
      <form>
        <Headline5>History</Headline5>
        <Table type='checkHistory' data={props.data} onClose={props.onClose} sendReminder={props.sendReminder} />
        <div className="popupAction">
          <Button variant="secondary" onClick={props.onClose}>Cancel</Button>
        </div>
      </form>
    </Modal>
  )
}
export default CheckHistory